import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "text-black font-[700] rounded-[6px] shadow-none text-sm bg-transparent hover:bg-transparent cursor-pointer",
  {
    variants: {
      variant: {
        default:
          "bg-[#FFD44D] hover:bg-[#F2C949]  disabled:text:slate-400 disabled:opacity-30",
        secondary:
          "bg-gray-100 hover:text-gray-900 hover:bg-gray-100 hover:opacity-80",
        destructive:
          "bg-red-600 text-zinc-50 hover:bg-red-600 hover:opacity-90",
        outline:
          "border border-[#FFD44D] text-black hover:bg-[rgba(255,244,215,0.8)]",
        ghost: "text-zinc-950 hover:bg-zinc-100",
        link: "text-[#155FCC] underline-offset-4 hover:underline",
        blue: "text-[#155FCC] ",
        light: "bg-[#FFF4D7] hover:bg-[#FFD44D] text-black",
        icon: "",
        filter:
          "flex items-center gap-[8px] bg-white border px-2.5 h-8 py-[7px] border-zinc-200 rounded-[6px] text-xs font-medium text-gray-950 font-[Geist]",
        pending:
          "text-zinc-50 bg-[#18181B80] hover:bg-[#18181B80] [&_svg]:color-[#FFF] [&_svg]:w-3.5! [&_svg]:h-3.5!",
      },
      size: {
        xs: "text-xs",
        sm: "h-9 px-3",
        md: "h-10 px-4 text-sm",
        lg: "h-11 px-6 text-base",
      },
      full: {
        true: "w-full",
        false: "",
      },
      iconSize: {
        sm: "[&_svg]:w-4 [&_svg]:h-4",
        md: "[&_svg]:w-5 [&_svg]:h-5",
        lg: "[&_svg]:w-6 [&_svg]:h-6",
        xl: "[&_svg]:w-7 [&_svg]:h-7",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
      full: false,
      iconSize: "md",
    },
  }
);
